import React from 'react'

function Loading() {
    return (
        <div className="loading">
        <h1 className="header ">LOADING... </h1>
      </div>
    )
}

export default Loading
